import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Box,  Text, Stack } from "@chakra-ui/react";
import StepSideBar from "../components/shared/StepSidebar";

export default function FreelancerLayout() {
  const location = useLocation();
  const pathName = location.pathname.includes("message");

  return (
    <>
      <Box pos="relative">
        <Header freelancer />
        <StepSideBar width="150px">
          <Stack>
            {freelancerLinksData.map((item, index) => {
              const active = location.pathname.includes(item.href);
              return (
                <Link to={"/freelancer" + item.href} key={index}>
                  <Text
                    color={active ? "brand.500" : "#000000AB"}
                    px={{ base: 2, md: 3, "2xl": 8 }}
                    py={4}
                    fontSize={{
                      base: "10px",
                      md: "10px",
                      lg: "15px",
                      "2xl": "18px",
                    }}
                    fontWeight="semibold"
                  >
                    {item.name}
                  </Text>
                </Link>
              );
            })}
          </Stack>
        </StepSideBar>
      </Box>
      <Outlet />
      {!pathName && <Footer />}
    </>
  );
}
const freelancerLinksData = [
  {
    name: "Dashboard",
    href: "/dashboard",
  },
  {
    name: "Messages",
    href: "/messages",
  },
  {
    name: "Orders",
    href: "/order",
  },
  {
    name: "Gigs",
    href: "/gigs",
  },
  {
    name: "Analytics",
    href: "/analytics",
  },
  {
    name: "Earnings",
    href: "/earnings",
  },
  {
    name: "Active Order",
    href: "/active-order",
  },
  {
    name: "Buy Bid Token",
    href: "/connects",
  },
];
